<div class="work-popup modal-dialog">
  <div class="modal-content">
    <div class="close-button" (click)="closePopUp()">
      <img src="assets/svg/closeButton.svg">
    </div>
    <div class="buttons-wrapper">
      <div class="flex-direction-row justify-content-between align-items-center flex-wrap">
        <div class="scroll-container">
          <button [ngClass]="{'active': sortType == ContentType.CONTACT}" (click)="scrollToSection(ContentType.CONTACT)"
                  class="outlined-button content-button tall-button">{{ 'content_modal.contact' | translate }}
          </button>
          <button [ngClass]="{'active': sortType == ContentType.SOCIAL_MEDIA}" (click)="scrollToSection(ContentType.SOCIAL_MEDIA)"
                  class="outlined-button content-button tall-button">{{ 'content_modal.social_media' | translate }}
          </button>
          <button [ngClass]="{'active': sortType == ContentType.PAYMENT}" (click)="scrollToSection(ContentType.PAYMENT)"
                  class="outlined-button content-button tall-button">{{ 'content_modal.payment' | translate }}
          </button>
          <button [ngClass]="{'active': sortType == ContentType.DOCUMENT}" (click)="scrollToSection(ContentType.DOCUMENT)"
                  class="outlined-button content-button tall-button">{{ 'content_modal.documents' | translate }}
          </button>
          <button [ngClass]="{'active': sortType == ContentType.BUSINESS}" (click)="scrollToSection(ContentType.BUSINESS)"
                  class="outlined-button content-button tall-button">{{ 'content_modal.business' | translate }}
          </button>
        </div>
        <div class="search-input-wrapper">
          <div class="header-search">
            <label for="registeredUsername">
              <img src="assets/svg/search.svg" alt="search icon">
              <input type="text" class="registered-username" id="registeredUsername" placeholder="{{ 'content_modal.search' | translate }}"
                     #searchInputEl (input)="searchType(searchInputEl)">
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="content-div">
      <ng-container *ngFor="let contentType of contentTypesList">
        <section  #{{contentType.type}} id="{{contentType.type}}">
          <app-user-card-content-list
            [contentType]="contentType.type"
            [content]="contentType.content"
            [showMore]="contentType.showMore"
            [documentsCount]="documentsCountNum"
            [userCardId]="userCardId">
          </app-user-card-content-list>
        </section>
      </ng-container>
    </div>
  </div>
</div>
